import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, FolderOutlined } from '@ant-design/icons';
import type { KnowledgeFolder } from '../models';

interface FolderBreadcrumbProps {
  breadcrumb: KnowledgeFolder[];
  onNavigate: (folderID: string | null) => void;
}

const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({ breadcrumb, onNavigate }) => {
  const items = [
    {
      key: 'root',
      title: (
        <a onClick={() => onNavigate(null)} style={{ cursor: 'pointer' }}>
          <HomeOutlined style={{ marginRight: 4 }} />
          所有知識
        </a>
      ),
    },
    ...breadcrumb.map((folder, idx) => ({
      key: folder.id,
      title:
        idx === breadcrumb.length - 1 ? (
          <span>
            <FolderOutlined style={{ marginRight: 4 }} />
            {folder.name}
          </span>
        ) : (
          <a onClick={() => onNavigate(folder.id)} style={{ cursor: 'pointer' }}>
            <FolderOutlined style={{ marginRight: 4 }} />
            {folder.name}
          </a>
        ),
    })),
  ];

  return (
    <Breadcrumb
      items={items}
      style={{ marginBottom: 12, fontSize: 13 }}
    />
  );
};

export default FolderBreadcrumb;
